// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"8a9d8976","567":"d33f4b71","927":"8a9d8976"}[chunkId] + ".chunk.css";
};